var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"space-between",attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"4"}},[_c('content-downloader',{attrs:{"file-data":_vm.fileData,"file-name":_vm.fileName}})],1),_c('v-spacer'),_c('v-col',{attrs:{"align":"end","cols":"6"}},[_c('content-filter',{attrs:{"filter-placeholder":"Text"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }